import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const TitleWrapper = styled.div`
  margin-bottom: 30px;
  font-size: 18px;
  line-height: 1.2;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 22px;
  }
`

const Border = styled.div`
  border-left: 3px solid
    ${props => (props.negative ? "#fff" : "var(--primary)")};
  padding-left: 12px;
`

const Suptitle = styled.div`
  margin-bottom: 5px;
  font-size: 1em;
  font-weight: 500;
`

const MainTitle = styled.h2`
  font-weight: 700;
  font-size: 1.5em;
  margin: 0 0 4px;
`

const Subtitle = styled.div`
  max-width: 455px;
  font-size: 0.8em;
  font-weight: 400;
`

const Title = ({ suptitle, title, subtitle, negative, className }) => {
  if (!suptitle && !title && !subtitle) {
    return null
  }

  let classes = "title"

  if (className) {
    classes += ` ${className}`
  }

  return (
    <TitleWrapper className={classes}>
      <Border negative={negative} className="border">
        {suptitle && <Suptitle className="suptitle">{suptitle}</Suptitle>}
        {title && <MainTitle className="maintitle">{title}</MainTitle>}
        {subtitle && <Subtitle className="subtitle">{subtitle}</Subtitle>}
      </Border>
    </TitleWrapper>
  )
}

Title.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  negative: PropTypes.bool,
}

Title.defaultProps = {
  negative: false,
}

export { Title }
